import React from 'react';

const About = () => {
  return (
    <div className="custom-page">
      <h1>About Us</h1>
      <p>
        Welcome to our world of beautiful threads and timeless designs! We are proud to offer <b>handcrafted embroidery</b> services on a wide range of clothing — blending tradition with modern fashion.
      </p>
      <p>
        Whether it’s a stylish <b>kurti</b>, an elegant <b>dupatta</b>, a traditional <b>chundadi</b>, or a cool <b>T-shirt for all(mens and womens)</b>, we put our heart into every stitch. Our embroidery work is not just decoration — it’s an expression of culture, creativity, and quality.
      </p>
      <p>
        With years of experience, our team specializes in custom embroidery that adds a unique and personal touch to every fabric. We aim to bring out the best in your garments by using the finest threads, neat finishing, and beautiful patterns tailored to your style.
      </p>
      <p>
        From daily wear to festive collections — if it can be stitched, we can embroider it!
        Thank you for supporting local handwork and being part of our journey.
      </p>
      <p><strong>✨ Embroidery on Everything. Made with Love. ❤️</strong></p>
    </div>
  );
};

export default About;
